import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'op-product-dashboard-specialservice',
    templateUrl: './product-dashboard-specialservice.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDashboardSpecialServiceComponent {

}